"use client";

/**
 * FilaPlacar — #426 gesto 3: placar da fila de despacho (ADR-VID-005 fila
 * revisada).
 *
 * Presentational-only — toda a derivação de texto vive em
 * `@/lib/fila-helpers` (pure, testado com asserções reais). Este componente
 * só decide variant/ícone do Alert e (quando `info.canReprocess`) renderiza
 * o botão "Reprocessar" (#426 gesto 2 — chama o MESMO endpoint de despacho
 * do botão "Processar levantamento", sem caminho paralelo).
 */

import { RefreshCwIcon } from "lucide-react";

import { Alert, AlertAction, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import type { FilaPlacarInfo } from "@/lib/fila-helpers";

interface FilaPlacarProps {
  info: FilaPlacarInfo;
  /** Chamado ao clicar "Reprocessar" — só renderizado quando `info.canReprocess`. */
  onReprocess?: () => void;
  isReprocessing?: boolean;
}

export function FilaPlacar({ info, onReprocess, isReprocessing }: FilaPlacarProps) {
  const variant = info.status === "erro" ? "destructive" : "warning";

  return (
    <Alert variant={variant} data-testid="fila-placar" data-fila-status={info.status}>
      <AlertTitle>{info.headline}</AlertTitle>
      {info.detail && <AlertDescription>{info.detail}</AlertDescription>}
      {info.canReprocess && (
        <AlertAction>
          <Button
            size="sm"
            variant="outline"
            onClick={onReprocess}
            disabled={isReprocessing}
            data-testid="btn-reprocessar-fila"
          >
            <RefreshCwIcon className={`size-3.5 ${isReprocessing ? "animate-spin" : ""}`} />
            {isReprocessing ? "Reprocessando…" : "Reprocessar"}
          </Button>
        </AlertAction>
      )}
    </Alert>
  );
}
